/**
 * @fileoverview Cloudflare Turnstile — ตัวช่วยฝั่งหน้าเว็บ
 * @module utils/captcha
 *
 * เปิด/ปิดด้วย REACT_APP_CLOUDFLARE_SITE_KEY ตัวเดียว ไม่มีสวิตช์แยก :
 * มีคีย์จริง = แสดงวิดเจ็ตและส่งผลขึ้น API, ไม่มี = ไม่แสดงอะไรเลยและล็อกอินได้ตามปกติ
 *
 * ต้องตั้งคู่กับ TURNSTILE_SECRET_KEY ฝั่ง backend เสมอ (ดู config/turnstile.js) —
 * ใส่แต่ฝั่งนี้จะได้วิดเจ็ตที่ไม่มีใครตรวจ ส่วนใส่แต่ฝั่ง backend จะไม่มีวิดเจ็ตให้กด
 * แล้วล็อกอินไม่ได้ทั้งระบบ
 *
 * ตัดค่าตัวอย่างใน .env ทิ้งด้วย (your_cloudflare_site_key_here) ไม่งั้นเครื่องที่
 * คัดลอก .env มาแต่ยังไม่ได้ใส่คีย์จริงจะขึ้นวิดเจ็ตที่โหลดไม่ขึ้นค้างอยู่บนหน้าล็อกอิน
 */

const raw = (process.env.REACT_APP_CLOUDFLARE_SITE_KEY || "").trim();

/** Site key ที่ใช้ได้จริง — สตริงว่างแปลว่ายังไม่ได้ตั้งค่า */
export const CAPTCHA_SITE_KEY = raw && !raw.startsWith("your_") ? raw : "";

/** ต้องแสดงวิดเจ็ตและรอผลก่อนส่งฟอร์มหรือไม่ */
export const isCaptchaEnabled = () => !!CAPTCHA_SITE_KEY;
